import { Props as AlertProps } from '@jbhi-fi/lanyard-ui/components/Alert/Alert';

export const ALERTS: { [name: string]: AlertProps } = {
  resendSuccess: {
    showIcon: true,
    closable: true,
    type: 'success',
    heading: 'Verification code sent.',
  },
  resendError: {
    showIcon: true,
    closable: true,
    type: 'error',
    heading: "Couldn't resend the code.",
    content: 'Please try again another time.',
  },
  linkError: {
    showIcon: true,
    closable: true,
    type: 'error',
    heading: "Can't verify phone",
    content: 'We were unable to verify your phone, please contact customer service.',
  },
};

export const VALIDATION_ERRORS = {
  required: 'That code is invalid. All 4 digits are required.',
  invalid: "That code is invalid. Give it another go or tap 'Resend'.",
};
